import NotificationBell from '../../assets/img/icons/notification-bell.svg';
import { HTMLAttributes } from 'react';
import useNotifications from './hooks/useNotifications';

interface Props extends HTMLAttributes<HTMLButtonElement> {
  isOpen: boolean;
}
const NotificationButton = ({ isOpen, ...props }: Props): JSX.Element => {
  const notifications = useNotifications();

  const hasUnreadNotifications = notifications.some((notification) => !notification.pushIsRead);

  return (
    <button {...props} className={`notification-button ${isOpen ? 'active' : ''}`}>
      <img alt="notifications" height="20px" src={NotificationBell} />
      {hasUnreadNotifications && <span className="notifications-unread-indicator"></span>}
    </button>
  );
};

export default NotificationButton;
